import React, { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Loader from './Loader';

import { useDispatch, useSelector } from 'react-redux';

const LinkedInAuthMiddleware = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const code = searchParams.get('code');


  const loginType = searchParams.get('state').split('login_type=')[1];

  useEffect(() => {
      navigate('/linkedinurltwo',{
          state: {
              code,
              loginType
          }
      });
  },[])
  
  return (
    <div
      style={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Loader />
    </div>
  );
};

export default LinkedInAuthMiddleware;
